import React from "react";

import { UploadFileModal } from "../../UploadFileModal";

export const UploadFileModalHOC = ({
  backImagePreview, // dont need
  bckProgress, // dont need
  done,
  frontImagePreview, // dont need
  frProgress, // dont need
  insEdit, // dont need
  insuranceHide,
  insuranceType, // dont need
  onBackInputChange,
  onFrontInputChange,
  removeImg, // dont need
  showInsuranceCard,
}) => {
  return (
    <UploadFileModal
      onBackFileInputChange={(e) => onBackInputChange(e, "pri")}
      onCancel={insuranceHide}
      onFrontFileInputChange={(e) => onFrontInputChange(e, "pri")}
      onSubmit={() => done("pri")}
      show={showInsuranceCard}
    />
  );
};
